import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  UserQueryInput,
  UserQueryResult,
} from "../../../generated/gql/graphql";

const GET_USERS = gql`
  query ItemsUsers($input: UserQueryInput) {
    users(input: $input) {
      items {
        lastname
        id
        firstname
        email
      }
      totalCount
    }
  }
`;

export default function useUsers(
  query?: UserQueryInput
): QueryResult<UserQueryResult> {
  return useQuery<UserQueryResult>(GET_USERS, {
    variables: {
      input: query,
    },
  });
}
